import type {
  ArchetypeConfig,
  DynamicsConfig,
  StoneFlickingCoreConfig,
} from "../types/game-config";
import type { SpaceConfig } from "../types/space";

export const DEFAULT_SPACE_CONFIG: SpaceConfig = {
  centerX: 5,
  centerY: 5,
  radius: 5,
  boundaryPadding: 0.3,
} as const;

export const DEFAULT_DYNAMICS_CONFIG: DynamicsConfig = {
  timeStep: 1 / 60,
  frictionCoefficient: 3.0,
  velocityThreshold: 0.01,
  minImpulseMagnitude: 0.1,
  restitutionCoefficient: 0.8,
  maxSimulationSteps: 600,
} as const;

export const DEFAULT_ARCHETYPE_CONFIGS: ReadonlyArray<ArchetypeConfig> = [
  { archetype: "STONE", radius: 0.35, mass: 1.0 },
] as const;

export const DEFAULT_CONFIG: StoneFlickingCoreConfig = {
  space: DEFAULT_SPACE_CONFIG,
  dynamics: DEFAULT_DYNAMICS_CONFIG,
  archetypes: DEFAULT_ARCHETYPE_CONFIGS,
  maxTurns: 50,
} as const;
